export default __webpack_public_path__ + "static/media/Background_00083.f46a5bda.png";